<template>
  <Adminlte>
    Welcome Researcher!
  </Adminlte>
</template>

<script>
  import Adminlte from '@/components/template/Adminlte'

  export default {
    name: 'ResearcherHome',
    components: { Adminlte }
  }
</script>



// WEBPACK FOOTER //
// ResearcherHome.vue?6d34f4d2